import { addToGlobalThisRet } from "@plugins";
import Cropper from "cropperjs";

function editPhotoInit() {
    const image = document.querySelector(".js-edit-photo-init");
    if (image) {
        const controls = document.querySelector(".js-edit-photo-controls-init");
        const movableBtn = document.querySelector(".js-edit-photo-movable-init");
        const cropBtn = document.querySelector(".js-crop-photo-init > button");
        const cropper = new Cropper(image, {
            viewMode: 3,
            preview: ".edit-photo__preview-pic",
            minContainerWidth: 358,
            minContainerHeight: 358,
            minCropBoxWidth: 180,
            minCropBoxHeight: 180,
            aspectRatio: 1 / 1,
            guides: false,
            center: false,
            autoCropArea: 1,
        });

        // Init zoom by buttons
        if (controls) {
            const btnMinus = controls.querySelector(".edit-photo__controls-btn-minus");
            const btnPlus = controls.querySelector(".edit-photo__controls-btn-plus");
            btnMinus.addEventListener("click", () => {
                cropper.zoom(-0.1);
            });
            btnPlus.addEventListener("click", () => {
                cropper.zoom(0.1);
            });
        }

        // Init movable
        if (movableBtn) {
            movableBtn.addEventListener("click", () => {
                if (movableBtn.classList.contains("movable")) {
                    cropper.setDragMode("crop");
                    movableBtn.classList.remove("movable");
                } else {
                    cropper.setDragMode("move");
                    movableBtn.classList.add("movable");
                }
            });
        }

        // Init crop
        if (cropBtn) {
            cropBtn.addEventListener("click", () => {
                cropper.getCroppedCanvas({
                    maxWidth: 320,
                    maxHeight: 320,
                    imageSmoothingQuality: "high",
                });
            });
        }
    }
}

addToGlobalThisRet(editPhotoInit, "editPhotoInit");
